import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import * as Icon from 'react-feather';
import { useDispatch } from 'react-redux';

import { convertToMask } from '../../../utils/common';

import {
  setCallEnd,
  setCallNumber,
  setScreenType,
  useCallNumber
} from '../../../store/slices/dialSlice';
import { useUserDetails } from '../../../store/slices/authSlice';

const IncomingCallScreen = ({
  number,
  setNumber,
  answerCall,
  incomingInvitationRef,
  stopRingtone
}) => {
  const dispatch = useDispatch();
  const callNumber = useCallNumber();
  const user = useUserDetails();

  const handleEndCall = async () => {
    const invitation = incomingInvitationRef.current;
    if (!invitation) return;
    stopRingtone();
    try {
      await invitation.reject();
      dispatch(setCallEnd(true));
      setNumber('');
      dispatch(setCallNumber(''));
      dispatch(setScreenType(null));
      incomingInvitationRef.current = null;
    } catch (error) {
      console.error('Error rejecting call:', error);
    }
  };

  return (
    <div className="h-100 call-action-btn-container">
      <div className="mt-auto mb-auto text-white text-center fw-bold fs-4">
        {user?.process_details?.numberMasking === 'true'
          ? convertToMask(callNumber || number)
          : callNumber || number}
      </div>
      <div className="text-center conference-call-button-grid text-white mt-auto pb-4">
        <div className="d-flex justify-content-center">
          <Button className="back-button bg-danger" onClick={() => handleEndCall()}>
            <i className="bi bi-telephone-x" style={{ fontSize: '24px' }} />
          </Button>
        </div>
        <div className="d-flex justify-content-center">
          <Button className="back-button bg-call-color" onClick={() => answerCall()}>
            <Icon.PhoneCall className="back-icon text-white" />
          </Button>
        </div>
      </div>
    </div>
  );
};

IncomingCallScreen.propTypes = {
  number: PropTypes.string,
  setNumber: PropTypes.func,
  answerCall: PropTypes.func,
  stopRingtone: PropTypes.func,
  incomingInvitationRef: PropTypes.any
};

export default IncomingCallScreen;
